import { initialiserModeLancement } from './utils/modeLancement';

// Importé en tout premier par index.tsx : le mode de lancement (et l'éventuel nettoyage de
// session sur un nouveau lien) doit être résolu avant l'hydratation des stores zustand
// persistés en sessionStorage et avant le premier rendu (cf. ArreteComptableGuard).
initialiserModeLancement();
